/**
 * --------------------------------------------------------------------------
 * Select
 * --------------------------------------------------------------------------
 */

const select = ($ => {

	/**
	* ------------------------------------------------------------------------
	* Constants
	* ------------------------------------------------------------------------
	*/

	// const Default = {};

	/**
	* ------------------------------------------------------------------------
	* Class Definition
	* ------------------------------------------------------------------------
	*/

	class Select {

		constructor(element) {
			this.$select = $(element);
			this.$control = this.$select.find('.select__control');
			this.$selected = this.$control.children('option:selected') || this.control.children().first();
			this.$button = $('<button class="select__button" type="button"></button>');
			this.$options = $('<ul class="select__options select__options_hidden"></ul>');
			this.isOpen = false;
			this.init();
		}

		init() {
			this.$control.addClass('select__control_hidden');
			this.render();
		}

		render() {
			const self = this;

			this.$control
				.find('option')
					.each(function () {
						const $option = $('<li class="select__option"></li>').text($(this).text());
						if ($(this).index() === self.$selected.index()) {
							$option.addClass('select__option_active');
						}
						self.$options.append($option);
					});

			if (!this.$select.hasClass('select_view_unfolded')) {
				this.$button.text(this.$selected.text());
				this.$select.append(this.$button);
			}

			this.$select.append(this.$options);
		}

		refresh() {
			this.$select.empty();
			this.$options.empty();
			this.render();
		}


		open() {
			this.$select
				.addClass('select_active');
			this.isOpen = true;
		}

		close() {
			this.$select
				.removeClass('select_active');
			this.isOpen = false;
		}

		option($option) {
			if ($option) {
				if (Array.isArray($option)) {
					$option = $option[0];
				}
				if (!$option.hasClass('select__option_active')) {
					this.$control
						.children('option')
						.eq($option.index())
						.prop('selected', true);
					this.$control
						.trigger('change');
					this.$button
						.text($option.text());
					$option
						.addClass('select__option_active')
						.siblings()
						.removeClass('select__option_active');
				}
				this.close();
			}else {
				console.log('return option');
			}
		}

		static jQueryInterface(config, ...rest) {
			return this.each(function () {
				const $this = $(this);
				let data = $this.data('select');

				if (!data) {
					data = new Select(this, config);
					$this.data('select', data);
				}

				if (typeof config === 'string') {
					if (typeof data[config] === 'undefined') {
						throw new Error('No method named "' + config + '"');
					}
					data[config](rest);
				}
			});
		}
}

	/**
	* ------------------------------------------------------------------------
	* Data Api implementation
	* ------------------------------------------------------------------------
	*/

	$(document)
		.ready(() => {
			$('.select').each(function () {
				const $select = $(this);
				Select.jQueryInterface.call($select, $select.data());
			});
		})
		.click(() => {

			const $target = $(event.target);
			const $select = $target.closest('.select');
			const $option = $target.closest('.select__option');
			const $button = $target.closest('.select__button');

			if (!$select.length) {
				$('.select').select('close');
			}

			if ($option.length) {
				Select.jQueryInterface.call($select, 'option', $option);
			}

			if ($button.length) {
				if ($select.data('select').isOpen) {
					$select.select('close');
				}else {
					$select.select('open');
				}
			}
		});

	/**
	* ------------------------------------------------------------------------
	* jQuery
	* ------------------------------------------------------------------------
	*/

	$.fn.select = Select.jQueryInterface;
	$.fn.select.Constructor = Select;

	return Select;

})(jQuery);

export default select;



/** WEBPACK FOOTER **
 ** ./app/blocks/select/select.js
 **/